// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function TrendUpSoftBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 33 32"
				>
					<path
						fill="currentColor"
						fillRule="evenodd"
						d="M19.383 7.928a1.5 1.5 0 1 0 1.235 2.734l4.14-1.872c-.515 1.31-1.248 2.994-2.143 4.589-.923 1.643-1.951 3.07-3.002 3.931-1.017.832-1.824.976-2.598.644l-.019-.007c-.766-.336-1.326-1.077-2.213-2.28l-.027-.037c-.767-1.04-1.863-2.528-3.67-3.066l-.004-.002c-1.604-.476-3.078.018-4.251.806-1.144.768-2.134 1.893-2.942 3.014l-.021.029c-1 1.39-1.814 2.902-2.372 4.047a34.042 34.042 0 0 0-.827 1.834l-.063.156-.002.005a1.5 1.5 0 0 0 2.793 1.094l.002-.004.008-.021.038-.092a31.014 31.014 0 0 1 .748-1.657c.515-1.057 1.237-2.391 2.092-3.585l.02-.026c.718-1 1.47-1.814 2.198-2.304.708-.475 1.253-.56 1.722-.421h.002c.723.216 1.278.839 2.141 2.01l.153.208c.73.997 1.745 2.386 3.312 3.057l.028.012c2.16.912 4.139.146 5.652-1.093 1.484-1.215 2.732-3.029 3.717-4.784.945-1.682 1.71-3.424 2.251-4.783l1.737 3.844a1.5 1.5 0 0 0 2.734-1.236l-3.295-7.29a1.5 1.5 0 0 0-1.985-.749l-7.29 3.295Z"
						clipRule="evenodd"
					/>
				</svg>
			}
		</IconContainer>
	);
}
